import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Switch from '@mui/material/Switch';

import { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { authApi } from '../../services/api/api';
import { useNavigate } from 'react-router-dom';
import { Edit, Eye, ImageIcon, Star, Trash2, UserRound, X } from 'lucide-react';

export default function User({ user, handleDelete, newUser, setNewUser }: any) {

    const api = authApi()

    const [open, setOpen] = useState(false);

    const navigate = useNavigate()

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    async function deleteUser() {
        await handleDelete(user.id)
        handleClose()
    }

    const [file, setfile] = useState('')

    const [image, setImage] = useState(user?.img)

    const [name, setName] = useState(user?.name)

    const [email, setEmail] = useState(user?.email)

    const [password, setPassword] = useState('')

    const [checked, setChecked] = useState(user?.admin === 1 ? true : false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
    };

    const [open1, setOpen1] = useState(false);

    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    let inputRef = useRef<HTMLInputElement>(null)

    function handleImg() {
        if (inputRef) {
            inputRef.current?.click()
        }
    }

    function handleFile(e: React.ChangeEvent<HTMLInputElement>) {
        const selectedFiles = e.target.files as FileList

        if (selectedFiles?.[0].size > 1048576) {
            toast.error('A imagem não pode ultrapassar 1mb.', { theme: 'dark', toastId: 'password' })
            return
        }

        setfile(URL.createObjectURL(selectedFiles?.[0]))

        if (e.target.files) {

            const files = e.target.files[0]

            const reader = new FileReader()
            reader.readAsBinaryString(e.target.files[0])
            reader.onload = (ev: any) => {
                setImage(`data:${files.type};base64,${btoa(ev.target.result)}`)
            }
        }
    }

    async function handleUpdate() {

        if (name === '' || email === '' || password === '') {
            toast.error('Preencha todos os dados.', { theme: 'dark', toastId: 'dados' })
            return
        }
        toast.loading('carregando.', { theme: 'dark', toastId: 'loadingUser' })
        const data = {
            'name': name,
            'email': email,
            'password': password,
            'admin': checked,
            'img': image,
            'id': user.id
        }
        const response = await api.updateUser(data)

        toast.dismiss('loadingUser')
        if (response === 200) {
            setNewUser(!newUser)
            handleClose1()
            toast.success('Usuário cadastrado com sucesso.', { theme: 'dark', toastId: 'succesUser' })
        } else {
            toast.error('Ocorreu algum erro tente novamente mais tarde.', { theme: 'dark', toastId: 'errorUser' })
        }

    }

    let emailDisplay = user.email.split(' ')
    if (emailDisplay[0].length > 17 && window.screen.width < 500) {
        emailDisplay = emailDisplay[0].substring(0, 17) + '...'
    } else {
        emailDisplay = emailDisplay[0]
    }

    return (
        <div className="w-full rounded my-2 ">
            <div className="w-full bg-white dark:bg-white/5 rounded-2xl shadow-sm border border-gray-100 dark:border-white/5 p-4 transition-all hover:shadow-md hover:border-blue-200 dark:hover:border-blue-500/30">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">

                    {/* Info do Usuário */}
                    <div className="flex items-center gap-4 w-full">
                        <div className="relative ">
                            <img
                                src={user.img || require("../../assets/logos/logo-icon.png")}
                                alt={user.name}
                                className="max-w-14 max-h-10  rounded-full border-2 border-blue-50 dark:border-[#061c3f] shadow-sm"
                            />
                            {user.admin === 1 && (
                                <div className="absolute -top-1 -right-1 bg-amber-500 p-1 rounded-full shadow-sm">
                                    <Star size={10} className="text-white fill-current" />
                                </div>
                            )}
                        </div>

                        <div className="flex flex-col">
                            <span className={`text-xs font-bold uppercase tracking-wider ${user.admin === 1 ? 'text-amber-500' : 'text-blue4'}`}>
                                {user.admin === 1 ? 'Administrador' : 'Leitor'}
                            </span>
                            <h3 className="text-base font-bold text-slate-800 dark:text-white leading-tight">
                                {user.name}
                            </h3>
                            <span className="text-xs text-slate-400 dark:text-slate-500 mt-0.5">
                                {user.email}
                            </span>
                        </div>
                    </div>

                    {/* Ações Separadas por um divisor vertical no Desktop */}
                    <div className="flex items-center gap-2 pt-4 sm:pt-0 border-t sm:border-t-0 sm:border-l border-gray-100 dark:border-white/5 sm:pl-6 w-full sm:w-auto justify-center">
                        <button
                            onClick={() => navigate('/usuario', { state: user })}
                            className="p-2 text-slate-400 hover:text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-lg transition-all"
                            title="Visualizar"
                        >
                            <Eye size={17} />
                        </button>

                        <button
                            onClick={handleClickOpen1}
                            className="p-2 text-slate-400 hover:text-emerald-500 hover:bg-emerald-50 dark:hover:bg-emerald-900/20 rounded-lg transition-all"
                            title="Editar"
                        >
                            <Edit size={17} />
                        </button>

                        <button
                            onClick={handleClickOpen}
                            className="p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-all"
                            title="Excluir"
                        >
                            <Trash2 size={17} />
                        </button>
                    </div>
                </div>
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '32px',
                        backgroundImage: 'none',
                        overflow: 'hidden',
                        width: '100%',
                        maxWidth: '500px'
                    },
                }}
            >
                {/* CABEÇALHO DE ALERTA (GRADIENTE VERMELHO) */}
                <div className="bg-gradient-to-r from-red-600 to-red-800 px-6 py-6 flex justify-between items-center shadow-lg">
                    <div className="flex items-center gap-3">
                        <div className="bg-white/10 p-2.5 rounded-xl backdrop-blur-md">
                            <Trash2 className="text-white" size={17} />
                        </div>
                        <div>
                            <h2 className="text-lg font-bold text-white tracking-tight">Excluir Registro</h2>
                            <p className="text-red-100 text-[10px] uppercase tracking-widest font-medium">Ação Crítica</p>
                        </div>
                    </div>
                    <button onClick={handleClose} className="text-white/50 hover:text-white transition-colors">
                        <X size={20} />
                    </button>
                </div>

                <DialogContent className="pt-8 pb-4">
                    <div className="flex flex-col items-center text-center gap-4">
                        {/* Avatar do usuário para confirmar quem está sendo deletado */}
                        <div className="relative">
                            <img
                                src={user?.img || "../../assets/images/default-user.png"}
                                className="w-20 h-20 rounded-full object-cover border-4 border-red-500/20 shadow-lg"
                                alt=""
                            />
                            <div className="absolute -bottom-1 -right-1 bg-red-600 p-1.5 rounded-full border-4 border-white dark:border-[#001e42]">
                                <Trash2 size={12} className="text-white" />
                            </div>
                        </div>

                        <div className="flex flex-col gap-1">
                            <p className="text-sm text-gray-500 dark:text-gray-400">
                                Você tem certeza que deseja remover o usuário:
                            </p>
                            <h3 className="text-lg font-black text-slate-800 dark:text-white uppercase tracking-tight leading-tight px-4">
                                {user?.name}
                            </h3>
                        </div>

                        <div className="mt-2 p-3 bg-red-50 dark:bg-red-900/10 rounded-2xl border border-red-100 dark:border-red-500/10">
                            <p className="text-[10px] text-red-600 dark:text-red-400 font-bold uppercase tracking-[0.2em]">
                                Atenção: O acesso deste usuário será removido imediatamente.
                            </p>
                        </div>
                    </div>
                </DialogContent>

                <DialogActions className="p-6 pt-2 flex flex-col sm:flex-row gap-3 border-t border-gray-100">
                    <div className='w-full flex my-2'>
                        <button
                            onClick={handleClose}
                            className="w-full sm:flex-1 h-12 rounded-xl text-xs font-bold uppercase tracking-widest text-gray-400 hover:bg-gray-100 dark:hover:bg-white/5 transition-all"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={deleteUser}
                            className="w-full px-3 sm:flex-1 h-12 bg-red-600 hover:bg-red-700 text-white font-bold rounded-xl shadow-lg shadow-red-500/20 uppercase tracking-widest text-xs transition-all active:scale-[0.98] flex items-center justify-center gap-2"
                        >
                            Sim, Excluir
                        </button>
                    </div>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open1}
                onClose={handleClose1}
                aria-labelledby="alert-dialog-update"
                PaperProps={{
                    style: {
                        borderRadius: '32px',
                        backgroundImage: 'none',
                        overflow: 'hidden',
                        width: '100%',
                        maxWidth: '450px'
                    },
                }}
            >
                {/* CABEÇALHO COM GRADIENTE EMERALD (Diferente do cadastro para indicar edição) */}
                <div className="bg-gradient-to-r from-blue3 to-blue4 px-6 py-6 flex justify-between items-center shadow-lg">
                    <div className="flex items-center gap-3">
                        <div className="bg-white/10 p-2.5 rounded-xl backdrop-blur-md">
                            <UserRound className="text-white" />
                        </div>
                        <div>
                            <h2 className="text-lg font-bold text-white tracking-tight">Editar Perfil</h2>
                            <p className="text-white text-[10px] uppercase tracking-widest font-medium">ID do Usuário: {user?.id}</p>
                        </div>
                    </div>
                    <button onClick={handleClose1} className="text-white/50 hover:text-white transition-colors">
                        <X size={20} />
                    </button>
                </div>

                <DialogContent className="pt-8">
                    <div className="flex flex-col gap-6">

                        {/* SEÇÃO DA FOTO COM OVERLAY DE EDIÇÃO */}
                        <div className="flex flex-col items-center gap-2">
                            <div
                                onClick={handleImg}
                                className="relative group w-28 h-28 rounded-full bg-gray-100 dark:bg-white/5 border-2 border-dashed border-blue3 flex justify-center items-center cursor-pointer overflow-hidden transition-all hover:border-emerald-500 shadow-inner"
                            >
                                {image ? (
                                    <img src={image} alt="User" className="w-full h-full object-cover transition-transform group-hover:scale-110" />
                                ) : (
                                    <div className="flex flex-col items-center text-gray-400 font-bold uppercase text-[10px]">
                                        <ImageIcon fontSize="small" />
                                        <span>Trocar Foto</span>
                                    </div>
                                )}
                                <div className="absolute inset-0 bg-emerald-900/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                    <span className="text-[10px] text-white font-black uppercase tracking-tighter">Alterar</span>
                                </div>
                            </div>
                            <input name="image" type="file" accept="image/*" className="hidden" ref={inputRef} onChange={handleFile} />
                        </div>

                        {/* CAMPOS DE INPUT */}
                        <div className="flex flex-col gap-4">
                            <div className="flex flex-col gap-1.5">
                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-2">Nome do Usuário</label>
                                <input
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    type="text"
                                    className="w-full p-3.5 rounded-2xl bg-gray-50 dark:bg-[#061c3f] border border-gray-100 dark:border-white/5 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-emerald-500 transition-all shadow-inner font-medium"
                                />
                            </div>

                            <div className="flex flex-col gap-1.5">
                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-2">E-mail Corporativo</label>
                                <input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="email"
                                    className="w-full p-3.5 rounded-2xl bg-gray-50 dark:bg-[#061c3f] border border-gray-100 dark:border-white/5 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-emerald-500 transition-all shadow-inner font-medium"
                                />
                            </div>

                            <div className="flex flex-col gap-1.5">
                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-2">Nova Senha </label>
                                <input
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    type="password"
                                    placeholder=""
                                    className="w-full p-3.5 rounded-2xl bg-gray-50 dark:bg-[#061c3f] border border-gray-100 dark:border-white/5 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-emerald-500 transition-all shadow-inner"
                                />
                            </div>

                            {/* STATUS DE ADMIN COM DESTAQUE EMERALD */}
                            <div className="flex items-center justify-between p-4 bg-blue5/5 rounded-2xl border border-blue4/10 mt-2">
                                <div className="flex flex-col">
                                    <span className="text-sm font-bold text-blue2 ">Perfil Administrador
                                    </span>
                                    <span className="text-[10px] text-blue5  uppercase font-bold tracking-tighter">Permite gerenciar o acervo</span>
                                </div>
                                <Switch
                                    checked={checked}
                                    onChange={handleChange}
                                    sx={{
                                        '& .MuiSwitch-switchBase.Mui-checked': { color: '#10b981' },
                                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#10b981' },
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </DialogContent>

                <DialogActions className="p-8 pt-4">
                    <button
                        onClick={handleUpdate}
                        className="w-full h-14 bg-gradient-to-r bg-blue3 hover:bg-blue4 text-white font-black rounded-2xl shadow-xl shadow-emerald-500/20 uppercase tracking-widest text-xs transition-all active:scale-[0.98] flex items-center justify-center gap-2"
                    >
                        Salvar Alterações
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    )
}